/* eslint-disable */
export const ClientHelper = {
    getClientValidator() {
        return {
            isValid: false,
            firstName: '',
            lastName: '',
            check(model) {
                const firstName = (model.firstName || '').trim();
                const lastName = (model.lastName || '').trim();
                this.firstName = firstName ? '' : 'Please enter first name';
                this.lastName = lastName ? '' : 'Please enter last name';
                this.isValid = !this.firstName && !this.lastName;
            }
        }
    },
    getUnregisteredClientValidator() {
        return {
            isValid: false,
            firstName: '',
            lastName: '',
            check(model) {
                const firstName = (model.firstName || '').trim();
                const lastName = (model.lastName || '').trim();
                this.firstName = firstName ?
                    firstName.length > 1 ? ''
                    : 'Please enter at least 2 characters'
                    : 'Please enter first name';
                this.lastName = lastName ?
                    lastName.length > 1 ? ''
                    : 'Please enter at least 2 characters'
                    : 'Please enter last name';
                this.isValid = !this.firstName && !this.lastName;
            }
        }
    }
}
